import React, { useCallback, useEffect, useMemo, useState } from "react";
import BreadCrumb from "Common/BreadCrumb";
// Icons
import { Search, Plus, Trash2 } from "lucide-react";
import TableContainer from "Common/TableContainer";
import { Link } from "react-router-dom";
import DeleteModal from "Common/DeleteModal";
import Modal from "Common/Components/Modal";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import LoadingCounter from "Common/Components/LoadingCounterProps";
import ProductPriceInCropYearPageColumn from "Common/Components/ColumnData/ProductPriceInCropYearPage";
import Swl from "sweetalert2";
const ProductPriceInCropYearPage = () => {
  const [data, setData] = useState<any>([]);
  const [show, setShow] = useState<boolean>(false);
  const [eventData, setEventData] = useState<any>();
  const [reload, setreload] = useState<boolean>();
  const [load, setload] = useState<boolean>();
  const [errorMessage, setErrorMessage] = useState("");
  // Delete Modal
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);
  const [productListYearCrop, setproductListYearCrop] = useState<any>([]);
  const [productListYearCropValue, setproductListYearCropValue] = useState<any>(
    localStorage.getItem("crop_year_id") || null
  );
  const [datfactoryList, setdatfactoryList] = useState<any>([]);
  const [datafactoryID, setDataFactoryID] = useState<any>(null);

  // Get Data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const params: any = {
          sort_by: "updated_at",
          sort_order: "desc",
        };
        setData([]);
        if (productListYearCropValue && productListYearCropValue !== "null") {
          params.crop_year_id = productListYearCropValue;
          const res = await axios.get(
            "https://api.havirkesht.ir/product-price/",
            {
              params,
            }
          );
          const items = res?.data?.items || [];
          setData(items);
          setload(items.length <= 0);
        }
      } catch (error: any) {
        console.error("Error fetching data:", error);
        setErrorMessage(
          error?.message ? "" : "خطایی رخ داده است. لطفاً مجدداً تلاش کنید."
        );
        setload(true);
      }
    };
    fetchData();
  }, [reload, productListYearCropValue]);

  // Delete Data
  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell.id) {
      setEventData(cell.id);
    }
  };

  const handleDelete = async () => {
    if (eventData) {
      try {
        const res = await axios.delete(
          `https://api.havirkesht.ir/product-price/${eventData}`
        );
        if (res.status === 200) {
          toast.success("عملیات حذف با موفقیت انجام شد");
          setreload(!reload);
          setDeleteModal(false);
        } else {
          toast.error("مشکل در خذف داده");
        }
        setDeleteModal(false);
        setEventData(null);
      } catch (error) {
        toast.error("مشکل در حذف داده ");
      }
    }
  };

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    validation.handleSubmit();
  };

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("app_atkey");
      try {
        const response = await axios.get("https://api.havirkesht.ir/factory/", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setdatfactoryList(response.data?.items || []);
      } catch (error) {
        console.error("خطا در دریافت داده‌ها:", error);
      }
    };

    fetchData();
  }, []);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      sugar_price_per_kg: "",
      sugar_amount_per_ton_kg: "",
      pulp_price_per_kg: "",
      pulp_amount_per_ton_kg: "",
    },
    validationSchema: Yup.object({
      // year: Yup.string().required("لطفاً سال زراعی را انتخاب کنید"),
      sugar_price_per_kg: Yup.number().required("لطفاً قیمت قند را وارد کنید"),
      sugar_amount_per_ton_kg: Yup.number().required(
        "لطفاً سهمیه قند را وارد کنید"
      ),
      pulp_price_per_kg: Yup.number().required("لطفاً قیمت تفاله را وارد کنید"),
      pulp_amount_per_ton_kg: Yup.number().required(
        "لطفاً سهمیه تفاله را وارد کنید"
      ),
    }),
    onSubmit: async (values) => {
      if (!datafactoryID) {
        setShow(true);
        return Swl.fire("خطا", "لطفا کارخانه را انتخاب کنید", "error");
      }
      const newData = {
        ...values,
        factory_id: Number(datafactoryID),
        crop_year_id: Number(localStorage.getItem("crop_year_id")),
      };
      try {
        const res = await axios.post(
          "https://api.havirkesht.ir/product-price/",
          newData
        );
        if (res.status === 201) {
          toast.success("اطلاعات با موفقیت ثبت شد");
          setreload(!reload);
          setDataFactoryID(null);
        }
      } catch (error: any) {
        console.log(error);
        setDataFactoryID(null);
        if (error.status === 409) {
          return Swl.fire({
            title: "خطا در ثبت ",
            text: " قیمت محصول برای این سال  زراعی  قبلاً در سیستم ثبت شده است.",
            icon: "error",
          });
        }
        toast.error("خطا در ثبت اطلاعات");
      } finally {
        toggle();
      }
    },
  });

  const toggle = useCallback(() => {
    if (show) {
      setShow(false);
      setEventData("");
      validation.resetForm();
    } else {
      setShow(true);
      setEventData("");
      validation.resetForm();
    }
  }, [show, validation]);

  const columns = ProductPriceInCropYearPageColumn({ onClickDelete });
  const formatNumber = (num: number | string) => {
    if (num === null || num === undefined || num === "") return "";
    const numStr = num.toString()?.replace(/,/g, "");
    return numStr?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const parseFormattedNumber = (formattedNum: string) => {
    return formattedNum?.replace(/,/g, "");
  };
  return (
    <React.Fragment>
      <BreadCrumb pageTitle="ثبت قیمت کالا" title="هاویر کشت " />
      <DeleteModal
        show={deleteModal}
        onHide={deleteToggle}
        onDelete={handleDelete}
      />
      <ToastContainer
        position="top-center"
        closeButton={false}
        limit={1}
        rtl={true}
        className="font-Bold text-lg"
      />
      {errorMessage && <div>{errorMessage}</div>}
      <div className="card" id="employeeTable rtl">
        <div className="card-body">
          <div className="flex items-center gap-3 mb-4">
            <h6 className="text-15 grow">
              مجموع کالا ها (<b className="total-Employs">{data?.length}</b>)
            </h6>
            <div className="shrink-0">
              <Link
                to="#!"
                onClick={toggle}
                type="button"
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600"
              >
                <span className="align-middle rtl">ثبت قیمت کالا جدید</span>{" "}
                <Plus className="inline-block size-4 rtl" />
              </Link>
            </div>
          </div>
          {data && data.length > 0 ? (
            <TableContainer
              isPagination={true}
              columns={columns}
              data={data}
              isGlobalFilter={true}
              customPageSize={10}
              divclassName="-mx-5 overflow-x-auto"
              tableclassName="w-full whitespace-nowrap"
              theadclassName="ltr:text-left rtl:text-right bg-slate-100 dark:bg-zink-600"
              thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-b border-slate-200 dark:border-zink-500"
              tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
              PaginationClassName="flex flex-col items-center gap-4 px-4 mt-4 md:flex-row"
            />
          ) : (
            <LoadingCounter
              count={data ? 0 : 15}
              text={errorMessage ? errorMessage : "داده ای در جدول وجود ندارد"}
            />
          )}
        </div>
      </div>

      <Modal
        show={show}
        onHide={toggle}
        modal-center="true"
        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
        dialogClassName="w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600"
      >
        <Modal.Header
          className="flex items-center justify-between p-4 border-b dark:border-zink-500"
          closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500"
        >
          <Modal.Title className="text-16">
            {" "}
            تعیین قیمت کالا در سال زراعی
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
          <form
            className="create-form"
            id="create-form"
            onSubmit={validation.handleSubmit}
          >
            <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
              <div className="xl:col-span-11 dark:text-white text-gray-800 space-y-4">
                {/* سال زراعی */}
                <div className="flex flex-col items-center">
                  {/* قیمت قند */}
                  <div className="flex mt-2 mr-4 items-center">
                    <label
                      htmlFor="sugar_price_per_kg"
                      className="text-base font-medium mr-2"
                    >
                      کارخانه:
                    </label>
                    <select
                      id="factory"
                      className="p-2 border rounded bg-white text-gray-900 dark:border-gray-600 w-[15.5rem] mx-2"
                      value={datafactoryID || ""}
                      onChange={(e) => setDataFactoryID(e.target.value)}
                      required
                    >
                      <option value="" hidden>
                        لطفا کارخانه را انتخاب  کنید
                      </option>
                      {datfactoryList?.map((data: any) => (
                        <option key={data.id} value={data.id}>
                          {data.factory_name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="flex mt-2 mr-4 items-center">
                    <label
                      htmlFor="sugar_price_per_kg"
                      className="text-base font-medium mr-2"
                    >
                      قیمت قند:
                    </label>
                    <input
                      type="text"
                      id="sugar_price_per_kg"
                      name="sugar_price_per_kg"
                      className="form-input w-[15.5rem] mx-2 text-black font-[12px]"
                      placeholder="هزینه هر کیلوگرم به ریال"
                      onChange={(e) => {
                        const rawValue = parseFormattedNumber(e.target.value);
                        if (rawValue === "" || /^\d+$/.test(rawValue)) {
                          validation.setFieldValue(
                            "sugar_price_per_kg",
                            rawValue === "" ? "" : parseInt(rawValue, 10)
                          );
                        }
                      }}
                      value={formatNumber(validation.values.sugar_price_per_kg)}
                      onKeyDown={(e) => {
                        if (
                          !/[0-9]|Backspace|Delete|ArrowLeft|ArrowRight|Tab/.test(
                            e.key
                          )
                        ) {
                          e.preventDefault();
                        }
                      }}
                      inputMode="numeric"
                    />
                  </div>
                  {validation.touched.sugar_price_per_kg &&
                    validation.errors.sugar_price_per_kg && (
                      <p className="text-red-400 mr-24 mt-2">
                        {validation.errors.sugar_price_per_kg}
                      </p>
                    )}

                  {/* سهمیه قند */}
                  <div className="flex mt-2 mr-4 items-center">
                    <label
                      htmlFor="sugar_amount_per_ton_kg"
                      className="text-base font-medium mr-2"
                    >
                      سهمیه قند:
                    </label>
                    <input
                      type="text"
                      id="sugar_amount_per_ton_kg"
                      name="sugar_amount_per_ton_kg"
                      className="form-input w-[15.5rem] mx-2 text-black font-[12px]"
                      placeholder="مقدار سهمیه به ازای هر تن به کیلوگرم"
                      onChange={(e) => {
                        const rawValue = parseFormattedNumber(e.target.value);
                        if (rawValue === "" || /^\d+$/.test(rawValue)) {
                          validation.setFieldValue(
                            "sugar_amount_per_ton_kg",
                            rawValue === "" ? "" : parseInt(rawValue, 10)
                          );
                        }
                      }}
                      value={formatNumber(
                        validation.values.sugar_amount_per_ton_kg
                      )}
                      onKeyDown={(e) => {
                        if (
                          !/[0-9]|Backspace|Delete|ArrowLeft|ArrowRight|Tab/.test(
                            e.key
                          )
                        ) {
                          e.preventDefault();
                        }
                      }}
                      inputMode="numeric"
                    />
                  </div>
                  {validation.touched.sugar_amount_per_ton_kg &&
                    validation.errors.sugar_amount_per_ton_kg && (
                      <p className="text-red-400 mr-24 mt-2">
                        {validation.errors.sugar_amount_per_ton_kg}
                      </p>
                    )}

                  {/* قیمت تفاله */}
                  <div className="flex mt-2 mr-4 items-center">
                    <label
                      htmlFor="pulp_price_per_kg"
                      className="text-base font-medium mr-2"
                    >
                      قیمت تفاله:
                    </label>
                    <input
                      type="text"
                      id="pulp_price_per_kg"
                      name="pulp_price_per_kg"
                      className="form-input w-[15.5rem] mx-2 text-black font-[12px]"
                      placeholder="هزینه هر کیلوگرم به ریال"
                      onChange={(e) => {
                        const rawValue = parseFormattedNumber(e.target.value);
                        if (rawValue === "" || /^\d+$/.test(rawValue)) {
                          validation.setFieldValue(
                            "pulp_price_per_kg",
                            rawValue === "" ? "" : parseInt(rawValue, 10)
                          );
                        }
                      }}
                      value={formatNumber(validation.values.pulp_price_per_kg)}
                      onKeyDown={(e) => {
                        if (
                          !/[0-9]|Backspace|Delete|ArrowLeft|ArrowRight|Tab/.test(
                            e.key
                          )
                        ) {
                          e.preventDefault();
                        }
                      }}
                      inputMode="numeric"
                    />
                  </div>
                  {validation.touched.pulp_price_per_kg &&
                    validation.errors.pulp_price_per_kg && (
                      <p className="text-red-400 mr-24 mt-2">
                        {validation.errors.pulp_price_per_kg}
                      </p>
                    )}

                  {/* سهمیه تفاله */}
                  <div className="flex mt-2 mr-4 items-center">
                    <label
                      htmlFor="pulp_amount_per_ton_kg"
                      className="text-base font-medium mr-2"
                    >
                      سهمیه تفاله:
                    </label>
                    <input
                      type="text"
                      id="pulp_amount_per_ton_kg"
                      name="pulp_amount_per_ton_kg"
                      className="form-input w-[15.5rem] mx-2 text-black font-[12px]"
                      placeholder="مقدار سهمیه به ازای هر تن به کیلوگرم"
                      onChange={(e) => {
                        const rawValue = parseFormattedNumber(e.target.value);
                        if (rawValue === "" || /^\d+$/.test(rawValue)) {
                          validation.setFieldValue(
                            "pulp_amount_per_ton_kg",
                            rawValue === "" ? "" : parseInt(rawValue, 10)
                          );
                        }
                      }}
                      value={formatNumber(
                        validation.values.pulp_amount_per_ton_kg
                      )}
                      onKeyDown={(e) => {
                        if (
                          !/[0-9]|Backspace|Delete|ArrowLeft|ArrowRight|Tab/.test(
                            e.key
                          )
                        ) {
                          e.preventDefault();
                        }
                      }}
                      inputMode="numeric"
                    />
                  </div>
                  {validation.touched.pulp_amount_per_ton_kg &&
                    validation.errors.pulp_amount_per_ton_kg && (
                      <p className="text-red-400 mr-24 mt-2">
                        {validation.errors.pulp_amount_per_ton_kg}
                      </p>
                    )}
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="flex justify-center p-4 border-t dark:border-zink-500">
          <button
            type="button"
            onClick={handleClick}
            className="px-4 py-2 mt-4 font-bold justify-end text-white bg-blue-500 rounded hover:bg-blue-600"
          >
            ثبت اطلاعات
          </button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default ProductPriceInCropYearPage;
